import LayoutContainer from '../../../layout/layout-container/index';
import DetailField from '../user/detail-field';
import {dateTimeFormatUK} from '../../../../utils/commonFunctions';

const PpcLoadDetails = ({load}) => (
  <LayoutContainer>
    <div className="mg-bottom-10">
      <DetailField label="User name">
        {load.attributes['ppc-user']['first-name']}
        {' '}
        {load.attributes['ppc-user']['last-name']}
      </DetailField>
      <DetailField label="PPC account number">
        {load.attributes['ppc-user']['account-number']}
      </DetailField>
    </div>
    <div className="mg-bottom-20">
      <DetailField label="Load date">
        {dateTimeFormatUK(load.attributes['created-at'])}
      </DetailField>
      <DetailField label="Load type">
        {load.attributes['load-type']}
      </DetailField>
    </div>
  </LayoutContainer>
);

export default PpcLoadDetails;
